import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { IOpenReport } from 'app/core/interfaces/IGenericReport.interface';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { _downloadFileGeneric } from 'app/utils/trip2-query-builder/utils/helpers';
import { SweetAlertHelper } from '../helpers/sweet-alert-helper.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class GenericReportingService extends ParentService {

  currentUser: ICurrentUser = null;

  constructor(
    private _http: Http,
    private sweetAlertHelper: SweetAlertHelper,
    protected _loading: T2LoadingService
  ) {
    super();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  openGenericReport(data: IOpenReport): void {
    this._loading.show();
    const bodyString = data.bodyRequestReport;
    this._http.post(`${constant.URL_GENERIC_REPORT}/${data.numberReport}`, bodyString, this.headerPost())
      .map((res: any) => res.json())
      .finally(() => this._loading.hiden())
      .subscribe({
        next: (response: any) => {
          const urlReport = this.currentUser !== null ? `${response}` : '';
          this.openWindow(urlReport);
        },
        error: (error) => {
          this.errorReportAlert(error);
        }
      });
  }

  openReportBatch(data: IOpenReport): Observable<string> {
    const bodyString = data.bodyRequestReport;
    const url = `${constant.URL_BATCH_REPORT}/${data.numberReport}`;
    return this._http
      .post(url, bodyString, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  openECM837Report(data: IOpenReport): void {
    this._loading.show();
    const bodyString = data.bodyRequestReport;
    const url = `${constant.URL_SERVICE_INVOICE_BATCH}/ExportTripsByForm?batchId=${bodyString.parameters.invoicebatchid}`;
    this._http.post(url, {}, this.headerPost())
      .finally(() => this._loading.hiden())
      .subscribe({
        next: (response: any) => {
          _downloadFileGeneric(response._body, response.headers.get('X-Custom-Header-FileName'));
        },
        error: (error) => {
          this.errorReportAlert(error);
        }
      });
  }

  openWindow(urlReport: string): void {
    if (!urlReport || !this.currentUser) {
      return;
    }
    const params = [
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes'
    ].join(',');
    const popup  = window.open(urlReport, 'popup_window', params);
    popup.moveTo(0, 0);
  }

  errorReportAlert(error) {
    this.sweetAlertHelper.captureExceptionList(error.json().message, 'Error Running the Report!');
    throw (error.json().message);
  }
}

export interface ICurrentUser {
  enforcepassword: boolean;
  fullname: string;
  isClient: boolean;
  phone: string;
  reenterpassword: boolean;
  roleid: number;
  token: string;
  username: string;
  userprofileid: number;
  usertypeid: number;
}



// WEBPACK FOOTER //
// ./src/app/core/services/genericReporting.service.ts